import { render, staticRenderFns } from "./SetDisabled.vue?vue&type=template&id=67a4fafd"
import script from "./SetDisabled.vue?vue&type=script&lang=js"
export * from "./SetDisabled.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports